<template>
  <div class="taskProgress">
    <div class="content">
      <div class="itemLi" v-for="(item,index) in dataList" :key="index" style="padding:10px 16px;">
        <van-row gutter="10">
          <van-col span="18">{{$t('append_field.device_id')}}: {{ item.clNo }}</van-col>
          <van-col span="7" style="text-align: right;" >
            <van-button color="#FF5700"   size="small" @click="deleteBtn(item,'deleteSingle')">{{$t('append_field.delete')}}</van-button>
          </van-col>
        </van-row>
        <van-row gutter="12">
          <van-col span="24">{{$t('append_field.device_name')}}: {{ item.nickName }}</van-col>
        </van-row>
        <van-row gutter="12">
          <van-col span="24">{{$t('append_field.task_name')}}: {{ item.taskName }}</van-col>
        </van-row>
        <van-row gutter="10">
          <van-col span="12">{{$t('append_field.task_size')}}: {{ item.totalFileNum }}</van-col>
          <van-col span="12" style="text-align: right;">{{$t('append_field.speed')}}(kb/s): {{ item.downKb }}</van-col>
        </van-row>
        <van-row gutter="12">
          <van-col span="24">{{$t('append_field.download_progress')}}: {{ item.percent }}</van-col>
        </van-row>
        <van-row gutter="12">
          <van-col span="24">{{$t('append_field.download_status')}}: <span :class="item.strColor">{{ item.stateCh }}</span></van-col>
        </van-row>
      </div>
      <van-empty
          v-if="dataList.length === 0"
          class="custom-image"
          image="/static/images/terminal/empty-img.png"
          :description="$t('append_field.data_empty')"
      />
    </div>
    <div class="btns">
      <van-button color="#006EFF" size="small" @click="refresh">{{$t('append_field.refresh')}}</van-button>
      <div style="">
        <span style="display: inline-block;width: 10px"></span>
        <van-button color="#FF5700" size="small" @click="deleteBtn('','deleteAll')">{{$t('append_field.clear_all')}}</van-button>
        <span style="display: inline-block;width: 10px"></span>
        <van-button color="#FF5700"  size="small" @click="deleteBtn('','deleteFinish')">{{$t('append_field.clear_completed')}}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import {Toast, Dialog} from 'vant'

export default {
  inject: ['reload'],
  name: 'taskProgress.vue',
  data() {
    return {
      dataList: [],
      timer: 0,
    }
  },
  mounted() {
    this.getProgressData()
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.getProgressData()
    }, 3000)
  },
  methods: {
    getProgressData() {
      this.$ajax('/etv/selectPageEqTaskProgress.json').then(res => {
        let arr = res.data.data.psersonList
        // 1：下载成功；2：等待下载；其他：下载中
        arr.forEach(res => {
          if (res.state == 1) {
            res.stateCh = this.$t('append_field.download_success')
            res.strColor = 'strGreen'
          } else if (res.state == 2) {
            res.stateCh = this.$t('append_field.waiting_download')
            res.strColor = 'strGray'
          } else {
            res.stateCh = this.$t('append_field.downloading')
            res.strColor = 'strGray'
          }
        })
        this.dataList = arr
      })
    },
    deleteBtn(r1, r2) {
      let postData = {
        type: r2,
      }
      let msg = ''
      if (r2 == 'deleteSingle') {
        postData.id = r1.id
        msg = this.$t('append_field.confirm_delete')
      } else if (r2 == 'deleteAll') {
        msg = this.$t('append_field.confirm_delete_all')
      } else if (r2 == 'deleteFinish') {
        msg = this.$t('append_field.confirm_delete_selected')
      }

      if (this.dataList.length == 0) {
        Toast(this.$t('append_field.no_data_to_clear'))
        return
      }
      Dialog.confirm({
        title: this.$t('append_field.delete')
        , message: msg,
      }).then(() => {
        this.$ajax.post('/etv/deleteEqTaskProgressById.json', qs.stringify(postData)).then(res => {
          if(res.data.code===0){
            Toast(res.data.msg)
            this.getProgressData()
          }else {
            Toast(res.data.msg)
          }


        })
      })
    },
    refresh() {
      this.dataList = []
      this.getProgressData()
    }
  },
}
</script>

<style lang="scss">
.taskProgress {
  height: calc(100% - 0px);

  .btns {
    display: flex;
    height: 60px;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
  }

  .content {
    height: calc(100% - 60px);
    overflow-y: auto;

    .empty {
      height: 100px;
      width: 100%;
      text-align: center;
      line-height: 100px;
      color: #8c8c8c;
    }

    .itemLi {
      margin-top: 2px;
      background: #fff;
      font-size:  15px;

      .van-row {
        margin: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .van-col {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .strGreen {
            color: #2FC25B;
          }

          .strGray {
            color: #808080;
          }

          .strRed {
            color: red;
          }
        }
      }
    }
  }
}
</style>
